import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketLink } from '@market/react';
import { getLocalePath } from 'utilities/locales';

const Ct2LearnMore = () => {
  const { t, i18n } = useTranslation();

  if (!i18n.exists('productPage.connectedTerminal.learnMore')) {
    return null;
  }

  return (
    <MarketLink
      href={`/help${getLocalePath()}/article/7428-connect-your-square-terminal-to-spos`}
      target="_blank"
      className="medium-20"
    >
      {t('productPage.connectedTerminal.learnMore')}
    </MarketLink>
  );
};

export default Ct2LearnMore;
